export const formatRecurrence = (isRecurrence) => {
  return isRecurrence == true ? 'Sim' : 'Não'
}
